const styles = (theme) => ({
  overviewBorder: {
    borderRadius: 24,
    border: `1px solid ${theme.palette.common.grey50}`,
    '@media(max-width: 600px)': {
      marginTop: 40,
    },
  },
});

export default styles;
